import {
  DataByConsumoCreditoCompraActions,
  DataByConsumoCreditoCompraState,
  InitialState,
  RESET_AVISO_ASOCIADO_A_COMPRA,
  RESET_CV_ASOCIADO_A_COMPRA,
  RESET_DATA_ASOCIADO_A_COMPRA,
  UPDATE_AVISO_ASOCIADO_A_COMPRA,
  UPDATE_CV_ASOCIADO_A_COMPRA,
} from './types'

const DataByConsumoCreditoCompraReducer = (
  state: DataByConsumoCreditoCompraState = InitialState,
  action: DataByConsumoCreditoCompraActions
): DataByConsumoCreditoCompraState => {
  switch (action.type) {
    case UPDATE_AVISO_ASOCIADO_A_COMPRA: {
      return {
        ...state,
        avisoTransaction: action.payload,
        cvTransaction: null,
      }
    }

    case UPDATE_CV_ASOCIADO_A_COMPRA: {
      return {
        ...state,
        avisoTransaction: null,
        cvTransaction: action.payload,
      }
    }

    case RESET_AVISO_ASOCIADO_A_COMPRA: {
      return {
        ...state,
        avisoTransaction: null,
      }
    }

    case RESET_CV_ASOCIADO_A_COMPRA: {
      return {
        ...state,
        cvTransaction: null,
      }
    }

    case RESET_DATA_ASOCIADO_A_COMPRA: {
      return InitialState
    }
    default:
      return state
  }
}

export default DataByConsumoCreditoCompraReducer
